import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';

export interface TypeFeatureCardFields {
  buttonLabel: EntryFieldTypes.Symbol;
  cardTitle: EntryFieldTypes.Symbol;
  link?: EntryFieldTypes.Symbol;
  imageUrl?: EntryFieldTypes.Symbol;
  image: EntryFieldTypes.Object;
  imageAltText?: EntryFieldTypes.Symbol;
  style: EntryFieldTypes.Symbol<'OnDark' | 'OnLight'>;
  variant?: EntryFieldTypes.Symbol<'Primary' | 'Secondary' | 'Tertiary'>;
}

export type TypeFeatureCardSkeleton = EntrySkeletonType<
  TypeFeatureCardFields,
  'featureCard'
>;
export type TypeFeatureCard<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeFeatureCardSkeleton, Modifiers, Locales>;

export function isTypeFeatureCard<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeFeatureCard<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'featureCard';
}

export type TypeFeatureCardWithoutLinkResolutionResponse =
  TypeFeatureCard<'WITHOUT_LINK_RESOLUTION'>;
export type TypeFeatureCardWithoutUnresolvableLinksResponse =
  TypeFeatureCard<'WITHOUT_UNRESOLVABLE_LINKS'>;
export type TypeFeatureCardWithAllLocalesResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeFeatureCard<'WITH_ALL_LOCALES', Locales>;
export type TypeFeatureCardWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeFeatureCard<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>;
export type TypeFeatureCardWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeFeatureCard<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>;
